import React from "react";


const CircularProgress = ({className}) => <div className={`loader ${className}`} style={{width: 150}}>
  <img src={"/loader.svg"} alt="loader"/>
  Site is loading...
</div>;
export default CircularProgress;
